import { EventoTimelineFCA } from "@/mocks/fca";

interface Props {
  timeline: EventoTimelineFCA[];
}

const tipoColor: Record<string, string> = {
  cadastro: "bg-primary-500",
  vistoria: "bg-accent-500",
  foto: "bg-caution-500",
  documento: "bg-accent-500",
  manejo: "bg-warning-500",
  alteracao: "bg-danger-500",
};

export default function TreeTimeline({ timeline }: Props) {
  const formatDate = (dateStr: string) => {
    const [y, m, d] = dateStr.split("-");
    return `${d}/${m}/${y}`;
  };

  return (
    <div>
      <h3 className="text-sm font-semibold text-foreground-900 font-heading mb-4 flex items-center gap-2">
        <i className="ri-history-line text-foreground-600"></i>
        Linha do Tempo
      </h3>
      <div className="bg-white rounded-card border border-background-200/70 p-5">
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="space-y-0">
            {timeline.map((event, idx) => (
              <div key={event.id} className={`relative flex gap-4 ${idx === timeline.length - 1 ? "" : "pb-5"}`}>
                {/* Dot */}
                <div className={`relative z-10 w-[38px] h-[38px] rounded-full ${tipoColor[event.tipo] || "bg-foreground-500"} flex items-center justify-center shrink-0`}>
                  <i className={`${event.icone} text-white text-sm`}></i>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0 pt-1">
                  <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                    <span className="text-xs text-foreground-500">{formatDate(event.data)}</span>
                    <span className={`badge text-[10px] ${
                      event.tipo === "cadastro" ? "bg-primary-100 text-primary-700" :
                      event.tipo === "vistoria" ? "bg-accent-100 text-accent-700" :
                      event.tipo === "manejo" ? "bg-warning-100 text-warning-700" :
                      event.tipo === "foto" ? "bg-caution-100 text-caution-700" :
                      "bg-accent-100 text-accent-700"
                    }`}>
                      {event.tipo === "cadastro" ? "Cadastro" :
                       event.tipo === "vistoria" ? "Vistoria" :
                       event.tipo === "manejo" ? "Manejo" :
                       event.tipo === "foto" ? "Foto" :
                       event.tipo === "documento" ? "Documento" :
                       event.tipo}
                    </span>
                  </div>
                  <p className="text-sm font-semibold text-foreground-900">{event.titulo}</p>
                  <p className="text-xs text-foreground-600 mt-0.5 leading-relaxed">{event.descricao}</p>
                  <p className="text-[10px] text-foreground-500 mt-1 flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {event.tecnico}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}